import Vue from 'vue'

import generalActions from './actionTypes'
import generalMutations from './mutationTypes'

const actions = {
  [generalActions.FETCH_API_VERSION]: async ({ rootState, commit }) => {
    const response = await Vue.axios.get('/')
    commit(generalMutations.SET_API_VERSION, { response })
  },
  [generalActions.FETCH_FIELD_DEFINITIONS]: async ({ rootState, commit }) => {
    const response = await Vue.axios.get('/smartsearch/fields')
    commit(generalMutations.SET_FIELD_DEFINITIONS, response.data)
  },
  [generalActions.SET_PERMISSIONS]: async ({ commit }, user) => {
    commit(generalMutations.SET_PERMISSIONS, user.permissions)
  },
  [generalActions.TOGGLE_LOADING]: async ({ commit }, loadingState) => {
    commit(generalMutations.SET_LOADING, loadingState)
  },
  [generalActions.TOGGLE_SIDEBAR]: async ({ commit }, navbarState) => {
    commit(generalMutations.SET_SIDEBAR, navbarState)
  },
  [generalActions.TOGGLE_MOBILE_SIDEBAR]: async ({ commit }, navbarState) => {
    commit(generalMutations.SET_MOBILE_SIDEBAR, navbarState)
  },
  [generalActions.SET_GLOBAL_ALERT]: async ({ commit }, alert) => {
    commit(generalMutations.SET_ALERT_MESSAGE, alert)
  },
  [generalActions.LAUNCH_ALERT]: async ({ commit }, options) => {
    Vue.$notify(options)
  },
  [generalActions.SET_ERROR]: async ({ commit }, error) => {
    commit(generalMutations.SET_ERROR, error)
  },
  [generalActions.CLEAR_ERROR]: async ({ commit }) => {
    commit(generalMutations.CLEAR_ERROR)
  },
  [generalActions.GET_HELP_URL]: async (_) => {
    const response = await Vue.axios.get('/help-url')
    return response.data.url
  },
  [generalActions.SET_HELP_URL]: async ({ commit }, url) => {
    await Vue.axios.post('/help-url', { url })
  }
}

export default {
  ...actions
}
